import React, { useState } from 'react';
import { COLORS } from '../../../../utils/constants';
import { adminAPI } from '../../../../services/api';
import { useAdminToast } from '../../../../hooks/useAdminToast';

const TransactionsTab = ({ details, onRefresh }) => {
  const { toast } = useAdminToast();
  const [processing, setProcessing] = useState(null);

  const handleDepositAction = async (depositId, action, amount) => {
    if (!window.confirm(`${action === 'approve' ? 'Одобрить' : action === 'reject' ? 'Отклонить' : action === 'reset' ? 'Сбросить статус' : 'Удалить'} депозит?`)) return;
    setProcessing(depositId);
    try {
      if (action === 'approve') {
        await adminAPI.approveDeposit(depositId, amount);
      } else if (action === 'reject') {
        await adminAPI.rejectDeposit(depositId, 'Отклонено администратором');
      } else if (action === 'reset') {
        await adminAPI.resetDepositStatus(depositId);
      } else if (action === 'delete') {
        await adminAPI.deleteDeposit(depositId);
      }
      onRefresh();
    } catch (err) {
      toast.apiError(err);
    } finally {
      setProcessing(null);
    }
  };

  const handleWithdrawalAction = async (withdrawalId, action) => {
    if (!window.confirm(`${action === 'approve' ? 'Одобрить' : action === 'complete' ? 'Выполнить' : action === 'reject' ? 'Отклонить' : action === 'reset' ? 'Сбросить статус' : 'Удалить'} вывод?`)) return;
    setProcessing(withdrawalId);
    try {
      if (action === 'delete') {
        await adminAPI.deleteWithdrawal(withdrawalId);
      } else if (action === 'reset') {
        await adminAPI.resetWithdrawalStatus(withdrawalId);
      } else {
        await adminAPI.processWithdrawal(withdrawalId, action, null, 'Обработано администратором');
      }
      onRefresh();
    } catch (err) {
      toast.apiError(err);
    } finally {
      setProcessing(null);
    }
  };

  const getStatusColor = (status) => {
    const colors = {
      'pending': COLORS.primary,
      'approved': COLORS.success,
      'rejected': COLORS.danger,
      'completed': COLORS.success,
      'processing': COLORS.primary,
    };
    return colors[status] || COLORS.textSecondary;
  };

  const getStatusLabel = (status) => {
    const labels = {
      'pending': 'Ожидает',
      'approved': 'Одобрен',
      'rejected': 'Отклонён',
      'completed': 'Выполнен',
      'processing': 'В обработке',
    };
    return labels[status] || status;
  };

  return (
    <div>
      <h4 style={{ color: COLORS.text, fontSize: '14px', marginBottom: '12px' }}>Депозиты</h4>
      {details?.deposits?.length > 0 ? details.deposits.slice(0, 10).map((d, i) => (
        <div key={i} style={{ 
          padding: '12px', 
          backgroundColor: COLORS.background, 
          borderRadius: '8px', 
          marginBottom: '8px',
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <span style={{ color: COLORS.success, fontWeight: '600', fontSize: '16px' }}>+${d.amount}</span>
              <span style={{ color: COLORS.textSecondary, fontSize: '12px' }}>{d.currency || 'USD'}</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ 
                padding: '4px 8px', 
                borderRadius: '4px', 
                backgroundColor: `${getStatusColor(d.status)}20`, 
                color: getStatusColor(d.status), 
                fontSize: '11px',
                fontWeight: '600',
              }}>
                {getStatusLabel(d.status)}
              </span>
              <span style={{ color: COLORS.textSecondary, fontSize: '11px' }}>
                {new Date(d.created_at).toLocaleDateString('ru')}
              </span>
            </div>
          </div>
          
          {d.status === 'pending' && (
            <div style={{ display: 'flex', gap: '8px' }}>
              <button onClick={() => handleDepositAction(d.id, 'approve', d.amount)} disabled={processing === d.id} style={{ flex: 1, padding: '6px', backgroundColor: `${COLORS.success}20`, border: 'none', borderRadius: '4px', color: COLORS.success, fontSize: '11px', fontWeight: '600', cursor: 'pointer' }}>✓ Одобрить</button>
              <button onClick={() => handleDepositAction(d.id, 'reject')} disabled={processing === d.id} style={{ flex: 1, padding: '6px', backgroundColor: `${COLORS.danger}20`, border: 'none', borderRadius: '4px', color: COLORS.danger, fontSize: '11px', fontWeight: '600', cursor: 'pointer' }}>✕ Отклонить</button>
              <button onClick={() => handleDepositAction(d.id, 'delete')} disabled={processing === d.id} style={{ padding: '6px 12px', backgroundColor: COLORS.card, border: `1px solid ${COLORS.border}`, borderRadius: '4px', color: COLORS.textSecondary, fontSize: '11px', cursor: 'pointer' }}>Удалить</button>
            </div>
          )}
          {d.status !== 'pending' && (
            <div style={{ display: 'flex', gap: '8px' }}>
              <button onClick={() => handleDepositAction(d.id, 'reset')} disabled={processing === d.id} style={{ padding: '4px 8px', backgroundColor: `${COLORS.primary}15`, border: 'none', borderRadius: '4px', color: COLORS.primary, fontSize: '11px', cursor: 'pointer' }}>↺ В ожидание</button>
              <button onClick={() => handleDepositAction(d.id, 'delete')} disabled={processing === d.id} style={{ padding: '4px 8px', backgroundColor: 'transparent', border: 'none', color: COLORS.danger, fontSize: '11px', cursor: 'pointer', opacity: 0.7 }}>Удалить</button>
            </div>
          )}
        </div>
      )) : <div style={{ color: COLORS.textSecondary, fontSize: '13px' }}>Нет депозитов</div>}
      
      <h4 style={{ color: COLORS.text, fontSize: '14px', marginTop: '20px', marginBottom: '12px' }}>Выводы</h4>
      {details?.withdrawals?.length > 0 ? details.withdrawals.slice(0, 10).map((w, i) => (
        <div key={i} style={{ 
          padding: '12px', 
          backgroundColor: COLORS.background, 
          borderRadius: '8px', 
          marginBottom: '8px',
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <span style={{ color: COLORS.danger, fontWeight: '600', fontSize: '16px' }}>-${w.amount}</span>
              <span style={{ color: COLORS.textSecondary, fontSize: '12px' }}>{w.currency || 'USD'}</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ 
                padding: '4px 8px', 
                borderRadius: '4px', 
                backgroundColor: `${getStatusColor(w.status)}20`, 
                color: getStatusColor(w.status), 
                fontSize: '11px',
                fontWeight: '600',
              }}>
                {getStatusLabel(w.status)}
              </span>
              <span style={{ color: COLORS.textSecondary, fontSize: '11px' }}>
                {new Date(w.created_at).toLocaleDateString('ru')}
              </span>
            </div>
          </div>
          
          {w.address && (
            <div style={{ fontSize: '11px', color: COLORS.textSecondary, marginBottom: '8px', wordBreak: 'break-all' }}>
              Адрес: {w.address}
            </div>
          )}
          
          {(w.status === 'pending' || w.status === 'processing') && (
            <div style={{ display: 'flex', gap: '8px' }}>
              {w.status === 'pending' && (
                <button onClick={() => handleWithdrawalAction(w.id, 'approve')} disabled={processing === w.id} style={{ flex: 1, padding: '6px', backgroundColor: `${COLORS.success}20`, border: 'none', borderRadius: '4px', color: COLORS.success, fontSize: '11px', fontWeight: '600', cursor: 'pointer' }}>✓ Одобрить</button>
              )}
              {w.status === 'processing' && (
                <button onClick={() => handleWithdrawalAction(w.id, 'complete')} disabled={processing === w.id} style={{ flex: 1, padding: '6px', backgroundColor: `${COLORS.success}20`, border: 'none', borderRadius: '4px', color: COLORS.success, fontSize: '11px', fontWeight: '600', cursor: 'pointer' }}>✓ Выполнить</button>
              )}
              <button onClick={() => handleWithdrawalAction(w.id, 'reject')} disabled={processing === w.id} style={{ flex: 1, padding: '6px', backgroundColor: `${COLORS.danger}20`, border: 'none', borderRadius: '4px', color: COLORS.danger, fontSize: '11px', fontWeight: '600', cursor: 'pointer' }}>✕ Отклонить</button>
              <button onClick={() => handleWithdrawalAction(w.id, 'delete')} disabled={processing === w.id} style={{ padding: '6px 12px', backgroundColor: COLORS.card, border: `1px solid ${COLORS.border}`, borderRadius: '4px', color: COLORS.textSecondary, fontSize: '11px', cursor: 'pointer' }}>Удалить</button>
            </div>
          )}
          {w.status !== 'pending' && w.status !== 'processing' && (
            <div style={{ display: 'flex', gap: '8px' }}>
              <button onClick={() => handleWithdrawalAction(w.id, 'reset')} disabled={processing === w.id} style={{ padding: '4px 8px', backgroundColor: `${COLORS.primary}15`, border: 'none', borderRadius: '4px', color: COLORS.primary, fontSize: '11px', cursor: 'pointer' }}>↺ В ожидание</button>
              <button onClick={() => handleWithdrawalAction(w.id, 'delete')} disabled={processing === w.id} style={{ padding: '4px 8px', backgroundColor: 'transparent', border: 'none', color: COLORS.danger, fontSize: '11px', cursor: 'pointer', opacity: 0.7 }}>Удалить</button>
            </div>
          )}
        </div>
      )) : <div style={{ color: COLORS.textSecondary, fontSize: '13px' }}>Нет выводов</div>}
    </div>
  );
};

export default TransactionsTab;
